import cjquery from 'jquery';
import React, { Component } from 'react';
import StarRatings from 'react-star-ratings';
import { Col, Row } from 'reactstrap';

import language from '../../../../assets/languages/language';
import Loader from '../../../../common/loader';
import appRoutes from '../../../../routes/exams/gmat-focus/app-routes';
import ValidateSaveReportIcon from '../../../Common/ValidateSaveReportIcon';
import FD from '../../../RestAPI/fetchData';
import App_data from '../../../config/App_data';
import AlertMessage from '../../../config/alertMessage';
import FlashCard from '../../../../components/FlashCard';
import { isRevisionModeActive, renderHTMLContent } from '../../../../common/function';
import ViewQuestion from '../../../../Components-2025/QuestionBank/ViewQuestion';
import { CHOICE_KEYS, CHOICE_MAPPING, EXAM_NAMES } from '../../../../common/constant';
import { messages } from '../../../../common/messages';

const storage_session = JSON.parse(localStorage.getItem('localstorageval'));
/* eslint-disable */
class GMATCases extends Component {
  // =============================== TODO START =======================//
  constructor(props) {
    super(props);
    this.state = {
      isExpand: false,
      successAlert: false,
      alert_status: false,
      MessageTitle: App_data.messageTitle,
      MessageContent: AlertMessage.messageContent_gmat,
      questions: [],
      all_questions_state: [],
      token: '',
      idname: '',
      isError: false,
      ValidToken: false,
      reportLoading: false,
      chapter_id: '',
      offset: 0,
      limit: 1,
      choice_a: 'answer_box',
      choice_b: 'answer_box',
      choice_c: 'answer_box',
      choice_d: 'answer_box',
      choice_e: 'answer_box',
      result_block: 'card hide_block',
      report_block: 'card hide_block',
      clicked: false,
      choice: '',
      result: '',
      text_color: 'card-header',
      records: '',
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      flag_question: 'flag_question pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      bookmarkColor: '',
      flagCSS: 'fa fa-flag-o mark-action-btn',
      timerstopbtn: 'pause_btn icon-control-pause',
      save_text: `${language.LC().SAVE_QUESTION}`,
      savedQuestion: false,
      comment: 'card-block',
      flashcard: 'card-block',
      comment_data: '',
      flash_data: [],
      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
      comment_arrow: '',
      flash_card_arrow: '',
      flash_class: 'edit_right_padding',
      count: 0,
      rating: 0,
      rated: false,
      ratting_text: `${language.LC().RATE_THIS_QUESTION}`,
      validated: false,
      comment_update: 'hide_block',
      comment_save: 'btn btn-primary active pointer_class margin_bottom_20',
      comment_update_id: '',
      next_block: '',
      previ_block: '',
      question_length: '',
      timer_stop: false,
      timer_tag: `${language.LC().STOP}`,
      chaptername: '',
      all_cases: [],
      cases_display: '',
      cases_name: '',
      cases_length: '',
      case_id: '',
      cases_offset: '',
      casesquestion_length: '',
      chapters: '',
      display_loader: '',
      selectedmenu: 'cfa_2',
      subscriptionstatus: '',
      display_subcription: 'hide_block',
      display_cases: 'show_block',
      showCompletionQuestion: false,
      markAsCompleted: false,
      markAsNotCompleted: false,
      markCompleted: true,
      cases: [],
      exam_type: 'cfa_2',
      cfaUnlimitedPackage: '',
      cfaUnlimitedActiveExam: '',
      forumComment: '',
      category: 'CFA Level 2',
      tags: ['cfa-2', 'cfa', 'question', 'case'],
      isFlashCardHidden: true,
      tooltips: [
        {
          placement: `${language.LC().COMMENT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().REPORT_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
        {
          placement: `${language.LC().FLASHCARD_TOOLTIP_MESSAGE}`,
          text_align: 'right',
        },
      ],
      user_city: '',
      user_country: '',
      user_ip: '',
      user_state: '',
      user_continent: '',
      hide_case_left_arrow: '',
      hide_case_right_arrow: '',
      hide_question_left_arrow: '',
      hide_question_right_arrow: '',
      display_main_loader: 'hide_block',
      top_50: '',
      question_no: 1,
    };
    this.childRef = null;
    this.setChildRef = (element) => {
      this.childRef = element;
    };
    this.toggleAlert = this.toggleAlert.bind(this);
  }

  static contextTypes = {
    router: React.PropTypes.object,
  };

  saveForumComment(e) {
    this.setState({ forumComment: e.target.value });
  }

  changeCompletionStatus(e) {
    e.preventDefault();
    let data = {
      token: this.state.token,
      idname: this.state.idname,
      case_no: this.state.cases.casesingleData.case_number,
      completion_status: this.state.markAsCompleted,
      exam_type: this.state.exam_type,
      chapter_id: this.props.params.chapterid,
    };
    if (this.state.markAsCompleted === true) {
      FD.callAPI(App_data.backend_api + '/gmat-focus/question-bank/updateCases', data).then(
        (resp) => {
          if (resp.success) {
            this._getReadings();
          }
        },
      );
    } else {
      FD.callAPI(App_data.backend_api + '/gmat-focus/question-bank/updateCases', data).then(
        (resp) => {
          if (resp.success) {
            this._getReadings();
          }
        },
      );
    }
  }

  markCompleted() {
    this.setState({
      markAsCompleted: true,
      markAsNotCompleted: false,
      markCompleted: false,
    });
  }

  markNotCompleted() {
    this.setState({
      markAsCompleted: false,
      markAsNotCompleted: true,
      markCompleted: false,
    });
  }

  goPremium() {
    this.context.router.push({
      pathname: '/Subscribe/',
      state: {
        token: this.state.token,
        idname: this.state.idname,
        selectedMenu: this.state.selectedmenu,
      },
    });
  }
  toggleAlert() {
    this.setState({
      alert_status: !this.state.alert_status,
    });
  }

  /*
  ---------------------------------------------
    Function to change, time every second
  ---------------------------------------------
  */
  tick() {
    this.setState({ count: this.state.count + 1 });
    //console.log(this.state.count + 1);
  }

  /*
  -------------------------------------------------
    Function to redirect page to readings page
  -------------------------------------------------
  */
  _getReadings = () => {
    this.context.router.push({
      pathname: appRoutes.QUESTION_BANK_READING.replace(':id', this.props.params.chapterid),
    });
  };

  _getQuestions = () => {
    this.context.router.push({
      pathname: appRoutes.QUESTION_BANK_LIST_QUE.replace(':chapter_no', this.props.params.chapterid)
        .replace(':id', this.props.params.readingid)
        .replace(':subscriptionstatus', this.state.subscriptionstatus)
        .replace(':reading', this.state.questions.name),
    });
  };

  /*
  -----------------------------------------------------------------------------
    Function to check Right Or Wrong Answered and displayed clicked box
  -----------------------------------------------------------------------------
  */
  _getAnswer = (choice, questionId) => {
    this.setState({ clicked: true, choice: 'choice_' + choice }, () => {
      // console.log('choice ----> ', this.state.choice);
    });
    if (choice === 'a') {
      this.setState({
        choice_a: 'answer_box clicked_box',
        choice_b: 'answer_box',
        choice_c: 'answer_box',
        choice_d: 'answer_box',
        choice_e: 'answer_box',
      });
    } else if (choice === 'b') {
      this.setState({
        choice_b: 'answer_box clicked_box',
        choice_a: 'answer_box',
        choice_c: 'answer_box',
        choice_d: 'answer_box',
        choice_e: 'answer_box',
      });
    } else if (choice === 'c') {
      this.setState({
        choice_c: 'answer_box clicked_box',
        choice_a: 'answer_box',
        choice_b: 'answer_box',
        choice_d: 'answer_box',
        choice_e: 'answer_box',
      });
    } else if (choice === 'd') {
      this.setState({
        choice_d: 'answer_box clicked_box',
        choice_a: 'answer_box',
        choice_b: 'answer_box',
        choice_c: 'answer_box',
        choice_e: 'answer_box',
      });
    } else if (choice === 'e') {
      this.setState({
        choice_e: 'answer_box clicked_box',
        choice_a: 'answer_box',
        choice_b: 'answer_box',
        choice_c: 'answer_box',
        choice_d: 'answer_box',
      });
    }
    // const result = getDeviceDetails();
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      id: questionId,
      caseIndex: this.props.params.case_offset,
      city: this.state.user_city,
      country: this.state.user_country,
      state: this.state.user_state,
      continent: this.state.user_continent,
      ip: this.state.user_ip,
    };
    FD.callAPI(App_data.backend_api + '/gmat-focus/question-bank/trackUserRecord', data).then(
      (resp) => {
        if (resp.success) {
          this.setState({ ValidToken: true });
        }
      },
    );
  };

  /*
  ------------------------------------------------------------------------------
    Function to show Correct box and display right answer and store in database
  -------------------------------------------------------------------------------
    */
  handleQuestionValidate = (item, e) => {
    // console.log(this.props.params.chapterid);
    // console.log('item', item);
    // console.log(this.props.params.case_offset);
    // console.log(this.state.clicked, 'clicked');
    // console.log(this.state.choice, 'this.state.choice');
    if (this.state.clicked) {
      clearInterval(this.timer);
      // const chosen_answer = this.state.choice;
      var right_answer = 0;
      this.setState({ result_block: 'card show_block' });
      //console.log(item);
      if (item.right_choice === this.state.choice) {
        right_answer = 1;
        if (this.state.choice === 'choice_a') {
          this.setState({ choice_a: 'answer_box success' });
        } else if (this.state.choice === 'choice_b') {
          this.setState({
            choice_b: 'answer_box success',
          });
        } else if (this.state.choice === 'choice_c') {
          this.setState({
            choice_c: 'answer_box success',
          });
        } else if (this.state.choice === 'choice_d') {
          this.setState({
            choice_d: 'answer_box success',
          });
        } else if (this.state.choice === 'choice_e') {
          this.setState({
            choice_e: 'answer_box success',
          });
        }
        this.setState({
          result: 'CORRECT',
          text_color: 'card-header text_success',
          result_block: 'card show_block',
        });
      } else {
        right_answer = 0;
        if (this.state.choice === 'choice_a') {
          this.setState({ choice_a: 'answer_box failure' });
        } else if (this.state.choice === 'choice_b') {
          this.setState({
            choice_b: 'answer_box failure',
          });
        } else if (this.state.choice === 'choice_c') {
          this.setState({
            choice_c: 'answer_box failure',
          });
        } else if (this.state.choice === 'choice_d') {
          this.setState({
            choice_d: 'answer_box failure',
          });
        } else if (this.state.choice === 'choice_e') {
          this.setState({
            choice_e: 'answer_box failure',
          });
        }
        if (item.right_choice === 'choice_a') {
          this.setState({ choice_a: 'answer_box success' });
        } else if (item.right_choice === 'choice_b') {
          this.setState({
            choice_b: 'answer_box success',
          });
        } else if (item.right_choice === 'choice_c') {
          this.setState({
            choice_c: 'answer_box success',
          });
        } else if (item.right_choice === 'choice_d') {
          this.setState({
            choice_d: 'answer_box success',
          });
        } else if (item.right_choice === 'choice_e') {
          this.setState({
            choice_e: 'answer_box success',
          });
        }
        this.setState({
          text_color: 'card-header text_failure',
          result: 'INCORRECT',
          result_block: 'card show_block',
        });
      }
      if (!this.state.validated) {
        const { token, idname, count: time_done, choice: selected_choice } = this.state;
        const { id: question_id } = item;
        const { chapterid: chapter_id, case_offset: caseIndex } = this.props.params;
        var data = {
          token,
          idname,
          question_id,
          right_answer,
          time_done,
          chapter_id,
          caseIndex,
          selected_choice,
        };
        
        FD.callAPI(App_data.backend_api + '/gmat-focus/question-bank/saveStats', data).then(
          (resp) => {
            if (resp.success) {
              this.setState((prevState) => ({
                ValidToken: true,
                validated: true,
                all_questions_state: prevState.all_questions_state.map((question) =>
                  question.id === question_id
                    ? {
                        ...question,
                        'gmat_focus_question_stat.isSelectedChoice': right_answer,
                        'gmat_focus_question_stat.selected_choice': selected_choice,
                      }
                    : question,
                ),
              }));
              
            } else {
              this.setState({ ValidToken: false });
            }
            return resp;
          },
        );
      }
    }else{
      this.setState({
        isError: true,
      });
    }
  };

  _timer_funct = (item, e) => {
    if (this.state.timer_stop) {
      this.setState({ timer_stop: false, timer_tag: 'Stop' });
      clearInterval(this.timer);
      this.timer = setInterval(this.tick.bind(this), 1000);
    } else {
      this.setState({
        timer_stop: true,
      });
      clearInterval(this.timer);
    }
  };

  /*
  ------------------------------------------------------------------------
     Function to Display Saved Question on button and save in database
  -------------------------------------------------------------------------
    */
  _saveQuestion = (item, e) => {
    console.log('save Question ------> ', item);
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      chapter_id: this.props.params.chapterid,
      topic_name: item.name,
      reading_id: item.reading_id,
    };
    if (this.state.bookmarkCSS === 'fa fa-bookmark mark-action-btn-bookmark') {
      // return;
      FD.callAPI(App_data.backend_api + '/gmat-focus/question-bank/unsaveQuestion', data).then(
        (resp) => {
          if (resp.success) {
            if (this.childRef) {
              this.childRef.deleteFlash();
            }
            this.setState({
              ValidToken: true,
              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
              bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
              bookmarkColor: '',
              save_text: `${language.LC().SAVE_QUESTION}`,
              isFlashCardHidden: true,
            });
          } else {
            this.setState({ ValidToken: false });
          }
          return resp;
        },
      );
    } else {
      FD.callAPI(App_data.backend_api + '/gmat-focus/question-bank/saveQuestion', data).then(
        (resp) => {
          if (resp.success) {
            this.setState({
              ValidToken: true,
              save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
              bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
              bookmarkColor: 'rgb(54, 141, 84)',
              save_text: `${language.LC().Question_Saved}`,
              isFlashCardHidden: false,
            });
          } else {
            this.setState({ ValidToken: false });
          }
          return resp;
        },
      );
    }
  };

  /*
  -------------------------------------
    Function to give star rattings
  -------------------------------------
    */
  onStarClick(item, nextValue, prevValue, name) {
    if (prevValue !== nextValue) {
      let params = {
        token: this.state.token,
        idname: this.state.idname,
        question_id: item.id,
        ratting: nextValue,
      };
      FD.callAPI(App_data.backend_api + '/gmat-focus/question-bank/UpdateGMATRatting', params).then(
        (response) => {
          if (response.success) {
            this.setState({ rated: 1, ratting_text: 'Rated ' });
          }
        },
      );
    }

    this.setState({ rating: nextValue });
    let params = {
      token: this.state.token,
      question_id: item.id,
      idname: this.state.idname,
    };
    FD.callAPI(App_data.backend_api + '/gmat-focus/question-bank/getGMATRatting', params).then(
      (response) => {
        var params = {
          token: this.state.token,
          idname: this.state.idname,
          question_id: item.id,
          ratting: nextValue,
        };
        if (response.success) {
          if (response.ratting.length > 0) {
            this.setState({ rated: true });
            response.ratting.map((items) =>
              this.setState({ rating: items.ratting, ratting_text: 'Rated ' }),
            );
          } else {
            FD.callAPI(
              App_data.backend_api + '/gmat-focus/question-bank/saveGMATRatting',
              params,
            ).then((response) => {
              if (response.success) {
                this.setState({ rated: 1, ratting_text: 'Rated ' });
              }
            });
          }
        } else {
          FD.callAPI(
            App_data.backend_api + '/gmat-focus/question-bank/saveGMATRatting',
            params,
          ).then((response) => {
            if (response.success) {
              this.setState({
                rated: 1,
                ratting_text: `Rated ${nextValue} stars`,
              });
            }
          });
        }
      },
    );
  }

  /*
  --------------------------------------
    Function to show Report box
  -------------------------------------
    */
  _displayReportForm = (item, e) => {
    this.setState({ report_block: 'card show_block' });
  };

  /*
  -------------------------------------------
    Funcion to save new report question
  -------------------------------------------
    */
  _reportQuestion = (item, e) => {
    var comment = document.getElementById('comment').value;
    if (comment.length < 2) {
      return;
    }
    console.log('items ----------> ', item);
    // const result = getDeviceDetails();
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      comment: comment,
      caseIndex: this.props.params.case_offset,
      city: this.state.user_city,
      country: this.state.user_country,
      state: this.state.user_state,
      continent: this.state.user_continent,
      ip: this.state.user_ip,
      topic_name: item.name,
      reading_id: item.reading_id,
    };
    this.setState({
      reportLoading: true,
    });
    FD.callAPI(App_data.backend_api + '/gmat-focus/question-bank/reportQuestion', data).then(
      (resp) => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            successAlert: true,
            reportLoading: false,
          });
          document.getElementById('comment').value = '';
        } else {
          this.setState({ ValidToken: false });
        }
        return resp;
      },
    );
  };

  onClose = (e) => {
    this.setState({
      report_block: 'card hide_block',
      successAlert: false,
    });
  };

  /*
  ---------------------------------
    Function to hide Report box
  ---------------------------------
  */
  _hideReportForm = (item, e) => {
    this.setState({ report_block: 'card hide_block' });
  };

  /*
  -----------------------------------
    Function to toggle Comment box
  ------------------------------------
  */
  _getToggleComment = (item, e) => {
    cjquery(this.refs['comment_toggle_div']).slideToggle(1000);
  };

  /*
  ------------------------------------
    Function to toggle Flash box
  ------------------------------------
    */
  _getToggleFlash = (item, e) => {
    cjquery(this.refs['flash_toggle_div']).slideToggle(1000);
  };

  /*
  ---------------------------------------------------------------------
    Function to Save flash Card And display new stored flash card
  ---------------------------------------------------------------------
  */
  _saveFlashCard = (item, e) => {
    if (document.getElementById('flash_card').value === '') {
      return;
    }

    var flash_card = document.getElementById('flash_card').value;
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      question_id: item.id,
      flash_card: flash_card,
    };
    FD.callAPI(App_data.backend_api + '/gmat-focus/question-bank/saveFlashCard', data).then(
      (resp) => {
        if (resp.success) {
          this.setState({ ValidToken: true });
          document.getElementById('flash_card').value = '';
          var params = {
            token: this.state.token,
            idname: this.state.idname,
            question_id: item.id,
          };
          FD.callAPI(App_data.backend_api + '/gmat-focus/question-bank/getFlashCards', params).then(
            (response) => {
              var flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;

              if (response.success) {
                this.setState({ ValidToken: true });

                if (response.flash_cards.length > 0) {
                  this.setState({
                    flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
                  });
                  flash_cards = response.flash_cards.map((items, index) => (
                    //alert(items.id)
                    <li key={index}>
                      <div className=''>
                        <ul className='icon_list'>
                          <li>
                            <a
                              className='pointer_class'
                              onClick={this._editFlash.bind(this, items)}
                            >
                              <i className='fa fa-pencil' />
                            </a>
                          </li>
                          <li>
                            <a
                              className='pointer_class'
                              onClick={this._deleteFlash.bind(this, items)}
                            >
                              <i className='fa fa-close' />
                            </a>
                          </li>
                        </ul>
                        <div className={this.state.flash_class}>
                          <h4 />
                          <p>{items.flash_card}</p>
                        </div>
                      </div>
                    </li>
                  ));
                } else {
                  this.setState({
                    flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
                  });
                }
                this.setState({ flash_data: flash_cards });
              } else {
                this.setState({
                  ValidToken: false,
                  flash_data: flash_cards,
                  flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
                });
              }
              return response;
            },
          );
        } else {
          this.setState({ ValidToken: false });
        }
      },
    );
  };

  /*
  ---------------------------------
    Function to Edit Flash card
  ---------------------------------
  */
  _editFlash = (item, e) => {
    this.setState({
      flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
    });
    document.getElementById('flash_card').value = item.flash_card;
  };

  /*
  --------------------------------------
     Function to delete flash card
  --------------------------------------
  */
  _deleteFlash = (item, e) => {
    var data = {
      token: this.state.token,
      idname: this.state.idname,
      flash_card: item,
    };
    FD.callAPI(App_data.backend_api + '/gmat-focus/question-bank/deleteFlashCard', data).then(
      (resp) => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
          });
          document.getElementById('flash_card').value = '';
          var flash_cards = <p>No Flash Card Found</p>;
          this.setState({ flash_data: flash_cards });
        } else {
          this.setState({ ValidToken: false });
        }
      },
    );
  };

  _getNext = () => {
    let { chapterid, caseid, case_offset, readingid } = this.props.params;
    if (this.state.questions.question_number === 6) {
      this.setState({ showCompletionQuestion: true });
    } else {
      this.setState({
        validated: false,
        rated: false,
        rating: 0,
        isError: false,
        ratting_text: 'Rate this Question',
        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
        save_text: `${language.LC().SAVE_QUESTION}`,
        timerstopbtn: 'pause_btn icon-control-pause',
        report_block: 'card hide_block',
      });
      const i = parseInt(this.props.params.offset, 10) + 1;
      this.setState({ offset: i });
      this.context.router.push({
        pathname: appRoutes.BEGIN_CASE.replace(':chapterid', chapterid)
          .replace(':readingid', readingid)
          .replace(':caseid', caseid)
          .replace(':case_offset', case_offset)
          .replace(':subscription', this.state.subscriptionstatus === 'paid' ? 1 : 0)
          .replace(':question_number', this.state.all_questions_state[i].question_no)
          .replace(':offset', i),
      });
    }
  };

  _getNextAnyway = () => {
    // console.log(this.state.questions)
    this.setState({
      display_loader: 'show_block',
      showCompletionQuestion: false,
    });
    if (this.props.params.question_number === this.state.casesquestion_length) {
      this.setState({
        validated: false,
        rated: false,
        rating: 0,
        isError:false,
        ratting_text: 'Rate this Question',
        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
        save_text: `${language.LC().SAVE_QUESTION}`,
        timerstopbtn: 'pause_btn icon-control-pause',
        report_block: 'card hide_block',
      });
      const i = 0;
      this.setState({ offset: i });

      this.context.router.push({
        pathname:
          '/cfa2_chapter/' +
          this.props.params.chapterid +
          '/' +
          this.props.params.caseid +
          '/' +
          this.props.params.case_offset +
          '/' +
          this.state.all_questions_state[i].question_number +
          '/' +
          0,
        state: {
          token: this.state.token,
          idname: this.state.idname,
          chapterid: this.props.params.chapterid,
          caseid: this.props.params.caseid,
          case_offset: this.props.params.case_offset,
          question_number: i,
          offset: 0,
        },
      });
    } else {
      //alert(this.state.casesquestion_length);
      this.setState({
        validated: false,
        rated: false,
        rating: 0,
        ratting_text: 'Rate this Question',
        save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
        bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
        save_text: `${language.LC().SAVE_QUESTION}`,
        timerstopbtn: 'pause_btn icon-control-pause',
        report_block: 'card hide_block',
      });
      const i = this.state.offset + 1;
      this.setState({ offset: i });
      //alert(i);
      this.context.router.push({
        pathname:
          '/cfa2_chapter/' +
          this.props.params.chapterid +
          '/' +
          this.props.params.caseid +
          '/' +
          this.props.params.case_offset +
          '/' +
          this.state.all_questions_state[i].question_number +
          '/' +
          i,
        state: {
          token: this.state.token,
          idname: this.state.idname,
          chapterid: this.props.params.chapterid,
          caseid: this.props.params.caseid,
          case_offset: this.props.params.case_offset,
          question_number: i,
          offset: i,
        },
      });
    }
  };

  _getPrevious = () => {
    this.setState({
      validated: false,
      rated: false,
      isError: false,
      rating: 0,
      ratting_text: 'Rate this Question',
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      save_text: `${language.LC().SAVE_QUESTION}`,
      timerstopbtn: 'pause_btn icon-control-pause',
      report_block: 'card hide_block',
    });
    document.getElementById('comment').value = '';
    let { chapterid, caseid, case_offset, readingid } = this.props.params;
    const i = parseInt(this.props.params.offset, 10) - 1;
    this.setState({ offset: i });
    this.context.router.push({
      pathname: appRoutes.BEGIN_CASE.replace(':chapterid', chapterid)
        .replace(':readingid', readingid)
        .replace(':caseid', caseid)
        .replace(':case_offset', case_offset)
        .replace(':subscription', this.state.subscriptionstatus === 'paid' ? 1 : 0)
        .replace(':question_number', this.state.all_questions_state[i].question_no)
        .replace(':offset', i),
    });
  };

  _getNextCase = () => {
    this.setState({
      display_cases: 'hide_block',
      display_subcription: 'hide_block',
      isError: false,
    });
    const casesoffset = parseInt(this.props.params.case_offset, 10) + 1;
    var caseid = '';
    if (this.state.cases_length > casesoffset) {
      this.setState({
        cases_offset: casesoffset,
      });
      caseid = this.state.all_cases[casesoffset].case_id;

      this.context.router.push({
        pathname: appRoutes.BEGIN_CASE.replace(':chapterid', this.props.params.chapterid)
          .replace(':readingid', this.props.params.readingid)
          .replace(':caseid', caseid)
          .replace(':case_offset', casesoffset)
          .replace(':subscription', this.state.subscriptionstatus === 'paid' ? 1 : 0)
          .replace(':question_number', this.state.all_cases[casesoffset].question_no)
          .replace(':offset', 0),
      });
      //this.setState({all_cases:caseid});
      // this.context.router.push({
      //   pathname:
      //     '/cfa2_chapter/' +
      //     this.props.params.chapterid +
      //     '/' +
      //     caseid +
      //     '/' +
      //     casesoffset +
      //     '/' +
      //     '1' +
      //     '/' +
      //     0,
      //   state: {
      //     token: this.state.token,
      //     idname: this.state.idname,
      //     chapterid: this.props.params.chapterid,
      //     caseid: caseid,
      //     case_offset: casesoffset,
      //     question_number: 1,
      //     offset: 0,
      //   },
      // });
    } else {
      this.setState({ cases_offset: 0 });
      caseid = this.state.all_cases[0].id;
    }
  };

  _getPreviousCase = () => {
    this.setState({
      display_cases: 'hide_block',
      display_subcription: 'hide_block',
      isError: false,
    });
    // const casesoffset = parseInt(this.state.cases_offset, 10) + 1;
    const casesoffset = this.props.params.case_offset - 1;
    let caseid = this.state.all_cases[casesoffset].case_id;
    if (this.state.cases_offset === 0) {
      this.setState({
        cases_offset: casesoffset,
      });
    } else {
      this.setState({ cases_offset: casesoffset });
      this.context.router.push({
        pathname: appRoutes.BEGIN_CASE.replace(':chapterid', this.props.params.chapterid)
          .replace(':readingid', this.props.params.readingid)
          .replace(':caseid', caseid)
          .replace(':case_offset', casesoffset)
          .replace(':subscription', this.state.subscriptionstatus === 'paid' ? 1 : 0)
          .replace(':question_number', this.state.all_cases[casesoffset].question_no)
          .replace(':offset', 0),
      });
    }
  };

  componentWillReceiveProps(nextProps) {
    if (
      nextProps.params.question_number !== this.props.params.question_number &&
      nextProps.params.caseid === this.props.params.caseid
    ) {
      // console.log('I am here for pffset ----. ', nextProps.params.offset);
      this._changeQuestion(
        nextProps.params.chapterid,
        nextProps.params.caseid,
        nextProps.params.case_offset,
        nextProps.params.question_number,
        this.state.token,
        this.state.idname,
        nextProps.params.offset,
      );
      // this.setState({ display_loader: 'show_block' });
    }

    if (nextProps.params.caseid !== this.props.params.caseid) {
      this._changeCase(
        nextProps.params.chapterid,
        nextProps.params.caseid,
        nextProps.params.case_offset,
        nextProps.params.question_number,
        this.state.token,
        this.state.idname,
        nextProps.params.offset,
      );
      this.setState({ display_loader: 'show_block' });
    }
  }

  /*
------------------------------------------------------
  on url question offset change run this function
-------------------------------------------------------
*/
getSelectedChoice = (question, selected) => {
  console.log('getSelectedChoice', question, selected);
  
  if (selected === 1) {
    return question.right_choice;
  }

  const selectedChoice = question['gmat_focus_question_stat.selected_choice'];
  if (selectedChoice && selectedChoice !== null && selectedChoice !== undefined) {
    return selectedChoice;
  }

  const wrongChoices = CHOICE_KEYS.filter((choice) => choice !== question.right_choice);
  const randomWrong = wrongChoices[Math.floor(Math.random() * wrongChoices.length)];

  return randomWrong;
};
setQuestionState = (questionDetails) => {
  const selectedChoice = questionDetails['gmat_focus_question_stat.isSelectedChoice'];
  const hasSelectedChoice = selectedChoice !== null && isRevisionModeActive(EXAM_NAMES.GMAT_FOCUS);
  const { right_choice } = questionDetails;
  
  this.setState(
    {
      choice_name: CHOICE_MAPPING[right_choice] || '',
      isSelectedChoice: selectedChoice || null,
      choice: hasSelectedChoice ? this.getSelectedChoice(questionDetails, selectedChoice) : null,
      clicked: hasSelectedChoice,
      validated: hasSelectedChoice,
      result_block: `card ${hasSelectedChoice ? 'show_block' : 'hide_block'}`,
    },
    () => {
      if (hasSelectedChoice) {
        this.handleQuestionValidate(questionDetails);
      }
    },
  );
};
  _changeQuestion(chapterid, caseid, case_offset, question_number, token_id, idname, offset_val) {
    // console.log('all_cases ----> ', case_offset);
    // console.log('all_questions_state -----> ', question_number);
    this.setState({
      case_id: caseid,
      display_main_loader: 'show_block',
      display_cases: 'hide_block',
      top_50: 'top-50',
      choice:'',
      validated: false,
      ValidToken: true,
      choice_a: 'answer_box',
      choice_b: 'answer_box',
      choice_c: 'answer_box',
      choice_d: 'answer_box',
      choice_e: 'answer_box',
      result_block: 'card hide_block',
      rated: false,
      rating: 0,
      ratting_text: 'Rate this Question',
      save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
      bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
      save_text: `${language.LC().SAVE_QUESTION}`,
      timerstopbtn: 'pause_btn icon-control-pause',
      report_block: 'card hide_block',
    });
    // var data = {
    //   token: token_id,
    //   idname: idname,
    //   chapter_id: chapterid,
    //   reading_id: this.props.params.readingid,
    //   case_id: caseid,
    // };
    const { all_questions_state } = this.state;
    let offset_res = '';
    let questionid = '';
    // console.log(questionid);
    for (var i = 0; i < all_questions_state.length; i++) {
      if (i === parseInt(offset_val, 10)) {
        this.setState({
          hide_question_left_arrow: '',
          hide_question_right_arrow: '',
        });
        if (i === 0)
          this.setState({
            hide_question_left_arrow: 'menu_hide',
          });
        else if (i === all_questions_state.length - 1)
          this.setState({
            hide_question_right_arrow: 'menu_hide',
          });
        offset_res = i;
        questionid = all_questions_state[i].id;
        // console.log(all_questions_state[i]);
        this.setState({
          questions: all_questions_state[i],
          offset: offset_res,
          display_main_loader: 'hide_block',
          top_50: '',
          question_no: i + 1,
        });
        this.setQuestionState(all_questions_state[i]);
        this.getFavQuestions(all_questions_state[i].id);
        this.getGMATRatting(all_questions_state[i].id);
        this.getFlashCards(all_questions_state[i].id);
      }
      if (i === all_questions_state.length - 1) {
        this.setState({
          display_loader: 'hide_block',
          display_cases: 'show_block',
        });
      }
    }
    // this.setState({ timer_stop: false, timer_tag: 'Stop', count: 0 });
    // clearInterval(this.timer);
    // this.timer = setInterval(this.tick.bind(this), 1000);

    var script = document.createElement('script');
    script.type = 'text/javascript';
    script.src =
      'https://cdnjs.cloudflare.com/ajax/libs/mathjax/2.7.2/MathJax.js?config=TeX-MML-AM_CHTML'; // use the location of your MathJax

    document.getElementsByTagName('head')[0].appendChild(script);
  }

  _changeCase(chapterid, caseid, case_offset, question_number, token_id, idname, offset_val) {
    let data = {
      token: token_id,
      idname: idname,
      chapter_id: chapterid,
      case_id: caseid,
      reading_id: this.props.params.readingid,
      subscriptionstatus: this.state.subscriptionstatus,
    };
    this.setState({
      cases_display: '',
      cases_name: '',
    });

    this.setState({ case_id: caseid });
    FD.callAPI(App_data.backend_api + '/gmat-focus/question-bank/getCaseByReading', data).then(
      (resp) => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            choice_a: 'answer_box',
            choice_b: 'answer_box',
            choice_c: 'answer_box',
            choice_d: 'answer_box',
            choice_e: 'answer_box',
            result_block: 'card hide_block',
            rated: false,
            rating: 0,
            ratting_text: 'Rate this Question',
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
            bookmarkCSS: 'fa fa-bookmark-o mark-action-btn-bookmark',
            save_text: `${language.LC().SAVE_QUESTION}`,
            timerstopbtn: 'pause_btn icon-control-pause',
            report_block: 'card hide_block',
            display_main_loader: 'show_block',
            top_50: 'top-50',
            // hide_question_right_arrow: 'menu_show',
            // hide_question_left_arrow: 'menu_hide',
          });
          document.getElementById('comment').value = '';
          this.setState({ all_cases: resp.questions });
          for (var i = 0; i < resp.questions.length; i++) {
            if (parseInt(this.props.params.case_offset, 10) === i) {
              this.setState({
                hide_case_left_arrow: '',
                hide_case_right_arrow: '',
              });
              if (i === 0) this.setState({ hide_case_left_arrow: 'true' });
              else if (i === resp.questions.length - 1)
                this.setState({ hide_case_right_arrow: 'true' });

              this.setState({
                cases_display: resp.questions[i]['gmat_focus_case.passage'],
                cases_name: 'Case no : ' + (parseInt(i, 10) + 1),
              });
            }
          }
          this.setState({ display_loader: 'hide_block' });
          var param = {
            token: token_id,
            idname: idname,
            case_id: caseid,
            reading_id: this.props.params.readingid,
            subscriptionstatus: this.state.subscriptionstatus,
          };
          FD.callAPI(
            App_data.backend_api + '/gmat-focus/question-bank/getCasesquestion',
            param,
          ).then((resp_question) => {
            if (resp_question.success) {
              this.setState({
                casesquestion_length: resp_question.questions_details.length,
                display_main_loader: 'hide_block',
              });
              
              // console.log(
              //   'I am having a issue here -------->',
              //   resp_question.questions_details.length,
              //   question_number,
              //   offset_val
              // );
              if (resp_question.questions_details.length > offset_val) {
                //let ques_res=[];

                let offset_res = '';
                let questionid = '';
                // console.log(questionid);

                for (var i = 0; i < resp_question.questions_details.length; i++) {
                  // console.log(
                  //   'resp_question.questions_details[i].length',
                  //   resp_question.questions_details.length
                  // );
                  if (i === 0) {
                    this.setState({
                      hide_question_left_arrow: '',
                      hide_question_right_arrow: '',
                    });
                    if (i === 0)
                      this.setState({
                        hide_question_left_arrow: 'menu_hide',
                      });
                    if (i === resp_question.questions_details.length - 1)
                      this.setState({
                        hide_question_right_arrow: 'menu_hide',
                      });
                    offset_res = i;
                    questionid = resp_question.questions_details[i].id;
                    this.setState({
                      questions: resp_question.questions_details[i],
                      question_no: i + 1,
                    });
                    this.setQuestionState(resp_question.questions_details[i]);
                    this.getFavQuestions(resp_question.questions_details[i].id);
                    this.getGMATRatting(resp_question.questions_details[i].id);
                    this.getFlashCards(resp_question.questions_details[i].id);
                  }
                  if (i === resp_question.questions_details.length - 1) {
                    this.setState({ display_loader: 'hide_block' });
                  }
                }
                this.setState({
                  offset: offset_res,
                  all_questions_state: resp_question.questions_details,
                  display_cases: 'show_block',
                  top_50: '',
                });
                this.setState({ records: '' });
              } else {
                console.log('Not Valid');
              }
            }
          });
        } else {
          this.setState({ ValidToken: false, records: 'Result not found.' });
        }
        clearInterval(this.timer);
        this.timer = setInterval(this.tick.bind(this), 1000);
        return resp;
      },
    );
    this.setState({ timer_stop: false, timer_tag: 'Stop', count: 0 });
    // clearInterval(this.timer);
    // this.timer = setInterval(this.tick.bind(this), 1000);
  }

  _getSubscribe = () => {
    this.context.router.push({
      pathname: '/subscribe/',
      state: { token: this.state.token, idname: this.state.idname },
    });
  };

  // ==================== CHANGES BY ME START ==============================//
  expandScreen = () => {
    this.setState({
      isExpand: true,
    });
    var elem = document.getElementById('Progress1');
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.webkitRequestFullscreen) {
      /* Safari */
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      /* IE11 */
      elem.msRequestFullscreen();
    }
  };
  closeFullscreen = () => {
    this.setState({
      isExpand: false,
    });
    if (document.exitFullscreen) {
      document.exitFullscreen();
    } else if (document.webkitExitFullscreen) {
      /* Safari */
      document.webkitExitFullscreen();
    } else if (document.msExitFullscreen) {
      /* IE11 */
      document.msExitFullscreen();
    }
  };
  // ==================== CHANGES BY ME END ==============================//
  // =============================== TODO END =======================//
  async componentDidMount() {
    window.scrollTo(0, 0);
    var storage_session = JSON.parse(localStorage.getItem('localstorageval'));
    this.setState({
      token: storage_session['token'],
      idname: storage_session['idname'],
      display_loader: 'show_block',
      display_cases: 'hide_block',
    });
    this.setState({
      case_id: this.props.params.caseid,
    });
    let subscriptionstatusData;
    if (parseInt(this.props.params.subscription, 10) === 1) {
      this.setState({ subscriptionstatus: 'paid' });
      subscriptionstatusData = 'paid';
    } else {
      this.setState({ subscriptionstatus: 'free' });
      subscriptionstatusData = 'free';
    }
    var data = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      caseid: this.props.params.caseid,
      reading_id: this.props.params.readingid,
      chapter_id: this.props.params.chapterid,
      subscriptionstatus: subscriptionstatusData,
    };
    // -------------------------- CASE AND Question ---------------- //
    FD.callAPI(App_data.backend_api + '/gmat-focus/question-bank/getCaseByReading', data).then(
      (resp) => {
        if (resp.success) {
          this.setState({
            ValidToken: true,
            all_cases: resp.questions,
            cases_length: resp.questions.length,
          });
          console.log(
            'this.props.params.case_offset==============>GMAT',
            this.props.params.case_offset,
          );
          for (var i = 0; i < resp.questions.length; i++) {
            if (parseInt(this.props.params.case_offset, 10) === i) {
              if (i === 0)
                this.setState({
                  hide_case_left_arrow: 'true',
                });
              if (i === resp.questions.length - 1)
                this.setState({
                  hide_case_right_arrow: 'true',
                });
              this.setState({
                cases_offset: this.props.params.case_offset,
                cases_display: resp.questions[i]['gmat_focus_case.passage'],
                cases_name: 'Case no: ' + (parseInt(i, 10) + 1),
                case_id: resp.questions[i].case_id,
              });
            }
          }
          var param = {
            token: storage_session['token'],
            idname: storage_session['idname'],
            reading_id: this.props.params.readingid,
            case_id: this.state.case_id,
            subscriptionstatus: subscriptionstatusData,
          };
          FD.callAPI(
            App_data.backend_api + '/gmat-focus/question-bank/getCasesquestion',
            param,
          ).then((resp_question) => {
            // console.log('I am here 1111');
            if (resp_question.success) {
              this.setState({
                casesquestion_length: resp_question.questions_details.length,
                display_main_loader: 'hide_block',
              });
              // console.log(
              //   'I am having a issue here -------->',
              //   this.props.params,
              //   resp_question.questions_details.length,
              //   this.props.params.question_number - 1
              // );
              if (resp_question.questions_details.length > this.props.params.offset) {
                //let ques_res=[];

                let offset_res = '';
                let questionid = '';
                // console.log(questionid);

                for (var i = 0; i < resp_question.questions_details.length; i++) {
                  // console.log(
                  //   'resp_question.questions_details[i]',
                  //   resp_question.questions_details[i]
                  // );
                  if (i === parseInt(this.props.params.offset, 10)) {
                    if (i === 0)
                      this.setState({
                        hide_question_left_arrow: 'menu_hide',
                      });
                    if (i === resp_question.questions_details.length - 1)
                      this.setState({
                        hide_question_right_arrow: 'menu_hide',
                      });
                    offset_res = i;
                    questionid = resp_question.questions_details[i].id;
                    this.setState({
                      questions: resp_question.questions_details[i],
                      question_no: i + 1,
                    });
                    this.setQuestionState(resp_question.questions_details[i]);
                    this.getFavQuestions(resp_question.questions_details[i].id);
                    this.getGMATRatting(resp_question.questions_details[i].id);
                    this.getFlashCards(resp_question.questions_details[i].id);
                  }
                  if (i === resp_question.questions_details.length - 1) {
                    this.setState({ display_loader: 'hide_block' });
                  }
                }
                this.setState({
                  offset: offset_res,
                  all_questions_state: resp_question.questions_details,
                  display_cases: 'show_block',
                });

                this.setState({ records: '' });
              } else {
                console.log('Not Valid');
              }
            }
          });
        } else {
          this.setState({ ValidToken: false, records: 'Result not found.' });
        }
        clearInterval(this.timer);
        this.timer = setInterval(this.tick.bind(this), 1000);
        return resp;
      },
    );
    // -------------------------- CASE AND Question ---------------- //
    clearInterval(this.timer);
    this.timer = setInterval(this.tick.bind(this), 1000);
  }

  getFavQuestions = (questionid) => {
    var params_fav = {
      token: storage_session['token'],
      question_id: questionid,
      idname: storage_session['idname'],
      chapter_id: this.props.params.chapterid,
    };
    FD.callAPI(App_data.backend_api + '/gmat-focus/question-bank/getFavQuestions', params_fav).then(
      (response) => {
        if (response.success) {
          this.setState({
            save_question: 'book-mark pointer_class margin_right_10 margin_bottom_10',
            bookmarkCSS: 'fa fa-bookmark mark-action-btn-bookmark',
            bookmarkColor: 'rgb(54, 141, 84)',
            save_text: `${language.LC().Question_Saved}`,
            isFlashCardHidden: false,
          });
        } else {
          this.setState({ isFlashCardHidden: true, bookmarkColor:'' });
        }
      },
    );
  };
  getGMATRatting = (questionid) => {
    // console.log('I am inside getGMATRatting', questionid);
    var params = {
      token: storage_session['token'],
      question_id: questionid,
      idname: storage_session['idname'],
    };
    //Api to get ratting
    FD.callAPI(App_data.backend_api + '/gmat-focus/question-bank/getGMATRatting', params).then(
      (response) => {
        if (response.success) {
          this.setState({ rated: true });
          response.ratting.map((items) =>
            this.setState({
              rating: items.ratting,
              ratting_text: 'Rated ',
            }),
          );
        }
      },
    );
  };
  getFlashCards = (questionid) => {
    var params = {
      token: storage_session['token'],
      idname: storage_session['idname'],
      question_id: questionid,
    };
    //Api to fetch flashcard by question id
    FD.callAPI(App_data.backend_api + '/gmat-focus/question-bank/getFlashCards', params).then(
      (response) => {
        let flash_cards = <p>{language.LC().NO_FLASHCARD_FOUND}</p>;
        if (response.success) {
          this.setState({ ValidToken: true });
          if (response.flash_cards.length > 0) {
            this.setState({
              flash_form: 'col-xs-12 col-sm-12 col-md-12 hide_block',
            });
            flash_cards = response.flash_cards.map((items, index) => (
              <li key={index}>
                <div className=''>
                  <ul className='icon_list'>
                    <li>
                      <a className='pointer_class' onClick={this._editFlash.bind(this, items)}>
                        <i className='fa fa-pencil' />
                      </a>
                    </li>
                    <li>
                      <a className='pointer_class' onClick={this._deleteFlash.bind(this, items)}>
                        <i className='fa fa-close' />
                      </a>
                    </li>
                  </ul>
                  <div className={this.state.flash_class}>
                    <h4 />
                    <p>{items.flash_card}</p>
                  </div>
                </div>
              </li>
            ));
          } else {
            this.setState({
              flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
            });
          }
          this.setState({ flash_data: flash_cards });
        } else {
          this.setState({
            ValidToken: false,
            flash_data: flash_cards,
            flash_form: 'col-xs-12 col-sm-12 col-md-12 display_block',
          });
        }
        return response;
      },
    );
  };
  checkSubscription = (SubscriptionFile, resp, resp_cases) => {
    if (
      resp.profileInfo.exam_selected === '' &&
      resp.profileInfo.cfaUnlimitedPackage === '' &&
      resp.profileInfo.cfaUnlimitedActiveExam === ''
    ) {
      //here code for check case id free or not
      this.setState({
        subscriptionstatus: 'free',
      });
      if (resp_cases.casesingleData.free === 0) {
        this.setState({
          display_cases: 'hide_block',
          display_subcription: 'show_block',
        });
        this.toggleAlert();
      } else {
        this.setState({
          display_cases: 'show_block',
          display_subcription: 'hide_block',
        });
      }
    } else {
      this.setState({
        cfaUnlimitedPackage: resp.profileInfo.cfaUnlimitedPackage,
        cfaUnlimitedActiveExam: resp.profileInfo.cfaUnlimitedActiveExam,
      });
      //console.log(resp_cases.casesingleData.free+'----------');
      var data_arr = resp.profileInfo.exam_selected
        ? JSON.parse(resp.profileInfo.exam_selected)
        : null;
      var dataset = {
        token: storage_session['token'],
        idname: storage_session['idname'],
        examid: data_arr,
      };
      FD.callAPI(App_data.backend_api + '/checkout_v1/getExamsbyUser', dataset).then(
        (resp_exam) => {
          if (resp_exam.success) {
            var exam_data = resp_exam.examData;
            var selectedmen = this.state.selectedmenu;
            var isInArray_var = false;
            isInArray_var = SubscriptionFile.checkCfa2Subscription(
              selectedmen,
              exam_data,
              this.state.cfaUnlimitedPackage,
              this.state.cfaUnlimitedActiveExam,
            );
            if (isInArray_var) {
              this.setState({
                subscriptionstatus: 'paid',
                display_cases: 'show_block',
                display_subcription: 'hide_block',
              });
            } else {
              if (resp_cases.casesingleData.free === 0) {
                this.setState({
                  display_cases: 'hide_block',
                  display_subcription: 'show_block',
                });
              } else {
                this.setState({
                  subscriptionstatus: 'free',
                  display_cases: 'show_block',
                  display_subcription: 'hide_block',
                });
              }
            }
          } else {
            console.log('fail');
          }
        },
      );
    }
  };
  setAnswer = (answer) => {
    this.setState({ choice: answer[0], clicked: true });
  };
  render() {
    const {
      reportLoading,
      questions,
      isFlashCardHidden,
      showCompletionQuestion,
      display_subcription,
      display_cases,
      markAsCompleted,
      markAsNotCompleted,
      markCompleted,
      save_text,
      bookmarkCSS,
      bookmarkColor,
      ratting_text,
      rating,
      result_block,
      text_color,
      result,
      choice_a,
      choice_b,
      choice_c,
      choice_d,
      choice_e,
      hide_question_left_arrow,
      hide_question_right_arrow,
      questions: questionsState,
      choice,
      question_no,
      validated,
      report_block,
      successAlert,
      tooltips,
      isError,
    } = this.state;
    const questions_data_display = questions || {};
    let question_data;
    if (showCompletionQuestion) {
      question_data = (
        <div className='w-100'>
          <div className={`card-block ${display_subcription}`}>
            <div className='row'>
              <div className='col-md-12'>
                <div className='card 23434'>
                  <span>{language.LC().THIS_CASE_IS_AVAILABLE_FOR_PREMIUM_MEMBERS_ONLY}</span>
                </div>
              </div>
            </div>
          </div>
          <div className={`col-md-12 complete-section-wrap ${display_cases}`}>
            <div className='card'>
              <div className='card-header text-center'>
                {language.LC().Mark_this_Question_as_Completed}
                <div onClick={this._getNextAnyway} className='float-right text-right'>
                  <i className='fa fa-angle-right ques_arrow pointer_class' />
                </div>
              </div>
              <div className='card-block'>
                <div className='row'>
                  <div className='col-sm-12 text-center'>
                    <div className='row'>
                      <div className='col-sm-12 col-md-12 '>
                        <div className='quation-img'>
                          <img
                            src={
                              App_data.frontend_url + '/img/question_bank/question_icon_blue.svg'
                            }
                            className='margin_bottom_10'
                            alt=''
                          />
                        </div>
                        <div
                          contentEditable={false}
                          suppressContentEditableWarning={true}
                          className='margin_bottom_10 view_questionhtml bg_blue'
                        >
                          {language.LC().MARK_THIS_QUESTION_AS_COMPLETED}
                        </div>
                      </div>
                      <div className='complete-or-not-wrap'>
                        <div className='check-button-wrap'>
                          <div className='card-actions float-right'>
                            <label className='check_container margin_bottom_0'>
                              {language.LC().COMPLETED}
                              <input
                                type='checkbox'
                                id='mark_completed'
                                name='mark_completed'
                                value='select'
                                onClick={this.markCompleted.bind(this)}
                                checked={markAsCompleted}
                              />
                              <span className='checkmark' />
                            </label>
                          </div>
                          <div className='card-actions float-right'>
                            <label className='check_container margin_bottom_0'>
                              {language.LC().NOT_COMPLETED}
                              <input
                                type='checkbox'
                                id='mark_not_completed'
                                name='mark_not_completed'
                                value='select'
                                onClick={this.markNotCompleted.bind(this)}
                                checked={markAsNotCompleted}
                              />
                              <span className='checkmark' />
                            </label>
                          </div>
                        </div>
                        <div className='d-block text-center complete-quation-submit'>
                          <button
                            disabled={markCompleted}
                            onClick={this.changeCompletionStatus.bind(this)}
                            className='btn btn-primary pointer_class'
                          >
                            {language.LC().SUBMIT}
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    } else {
      question_data = (
        <div className='note-section'>
          <div className={`card-block ${display_subcription}`}>
            <div className='row'>
              <div className='col-sm-12 col-md-12 p-sm-0'>
                <div className='card'>
                  <div className='card-header'>
                    <h4>{language.LC().THIS_CASE_IS_AVAILABLE_FOR_PREMIUM_MEMBERS_ONLY}</h4>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className={`col-sm-12 col-md-12 p-sm-0 ${display_cases}`}>
            <div className='card box-shadow-none'>
              <div className='card-header title-font-size'>
                <div className='d-flex justify-content-between'>
                  <div className='d-flex'>
                    <img
                      src={App_data.frontend_url + '/img/question_bank/question_icon_blue.svg'}
                      className='margin_right_20'
                      alt=''
                      width='30'
                    />
                    <div className='title-font-size'>
                      {language.LC().QUESTION} {question_no + ' - '}
                    </div>
                  </div>
                  <div className='float-right text-right'>
                    <i
                      className={`fa fa-angle-left ques_arrow pointer_class ${hide_question_left_arrow}`}
                      onClick={this._getPrevious}
                    />
                    <i
                      className={`fa fa-angle-right ques_arrow pointer_class ${hide_question_right_arrow}`}
                      onClick={this._getNext}
                    />
                  </div>
                </div>
              </div>
              <div className='card-block'>
                <div className='row px-md-15px'>
                  <div>
                    <div className='row'>
                      <ViewQuestion
                        {...questions}
                        {...this.props}
                        setAnswer={this.setAnswer}
                        showAnswer={validated}
                        correctChoice={questions && questions.right_choice}
                        selectedChoice={choice}
                      />
                      <Col md={12} className='mt-2'>
                        {isError && <p className='text-danger'>{messages.NO_CHOICE_SELECTED}</p>}
                        <Row className='align-items-center'>
                          <ValidateSaveReportIcon
                            showResult={validated}
                            isQue={true}
                            _getResult={this.handleQuestionValidate}
                            _saveQuestion={this._saveQuestion}
                            _displayReportForm={this._displayReportForm}
                            all_questions={questions_data_display}
                            save_text={save_text}
                            bookmarkCSS={bookmarkCSS}
                            bookmarkColor={bookmarkColor}
                          />
                          <div className='col-lg-6 col-md-12 mt-md-1 mt-lg-0 text-lg-right'>
                            <div className='star_rating_wrap'>
                              <span className='margin_bottom_0 margin_right_10'>
                                {ratting_text}
                              </span>
                              <StarRatings
                                rating={rating}
                                starRatedColor='rgb(255, 180, 0)'
                                starEmptyColor='rgb(51, 51, 51)'
                                starDimension='20px'
                                starHoverColor='rgb(255, 180, 0)'
                                starSpacing='2px'
                                changeRating={this.onStarClick.bind(this, questions_data_display)}
                                numberOfStars={5}
                                name='rate1'
                              />
                            </div>
                          </div>
                        </Row>
                      </Col>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <div className={`${result_block} bg-faded`}>
              <div className={text_color}>{result}</div>
              <div className='card-block'>
                {renderHTMLContent(questions_data_display.answer, 'p', 'view_questionhtml', {
                  contentEditable: false,
                  suppressContentEditableWarning: true,
                })}
              </div>
              {console.log(questionsState)}
            </div>
            <FlashCard
              item={questions}
              type='question'
              question_type='question'
              isFlashCardHidden={isFlashCardHidden}
              ref={this.setChildRef}
              exam='gmat_focus'
            />
            <div className='row'>
              <div className='col-md-12'>
                <div className={report_block}>
                  <div className='card-header'>{language.LC().REPORT}</div>
                  {!successAlert ? (
                    <div className='card-block'>
                      <div className='row'>
                        <div className='col-sm-12'>
                          <label className='form-control-label' htmlFor='textarea-input'>
                            <strong>{language.LC().COMMENT}</strong>
                          </label>
                        </div>
                        <div className='col-sm-12 margin_bottom_10'>
                          <textarea
                            id='comment'
                            name='comment'
                            rows='6'
                            className='form-control'
                            placeholder='Content..'
                          />
                        </div>
                      </div>
                      <div className='row'>
                        <div className='col-sm-12'>
                          <button
                            type='button'
                            className='btn btn-primary active pointer_class margin_bottom_20 report-btn'
                            disabled={reportLoading}
                            onClick={this._reportQuestion.bind(this, questions_data_display)}
                          >
                            {reportLoading ? language.LC().PLEASE_WAIT : language.LC().REPORT}
                          </button>
                          <button
                            type='button'
                            className='btn btn-danger active pointer_class margin_left_10 margin_bottom_20'
                            onClick={this._hideReportForm.bind(this, questions_data_display)}
                          >
                            {language.LC().CANCEL}
                          </button>
                        </div>
                      </div>
                    </div>
                  ) : (
                    <div className='card-block'>
                      <div className='row'>
                        <div className='col-sm-12 report-Success-card'>
                          <img src={App_data.frontend_url + '/img/success-ic.svg'} alt='' />
                          <label className='form-control-label' htmlFor='textarea-input'>
                            <strong> {language.LC().REPORT_SEND_SUCCESS_MESSAGE}</strong>
                          </label>
                          <button
                            type='button'
                            className='btn btn-primary active pointer_class  min-vw-120'
                            onClick={this.onClose}
                          >
                            {language.LC().CLOSE}
                          </button>
                        </div>
                      </div>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      );
    }

    // const { timer_stop } = this.state;
    return (
      <div className='d-flex flex-column' id='Progress1'>
        {/* ========================= BODY ============================== */}
        <div className='margin_bottom_20 d-flex justify-content-between'>
          <div>
            <h1 className='section_head'>{language.LC().QUESTION_BANK}</h1>
          </div>
          {/* </div>

            <div className="col-sm-4 margin_bottom_20 text-sm-right"> */}
          <div>
            <button
              type='button'
              className='btn btn-primary pointer_class'
              onClick={this._getQuestions}
            >
              {language.LC().CHANGE_QUESTIONS}
            </button>
            <button
              type='button'
              className='btn btn-primary pointer_class'
              onClick={this._getReadings}
            >
              {language.LC().CHANGE_CHAPTER}
            </button>
          </div>
          {/* </div> */}
        </div>
        <div className='d-flex flex-sm-col'>
          {/* ============================ CASES ============================= */}
          <div
            className='p-2 card mr-1 mb-0 calc_height_GMAT overflow-y-auto width-sm-100 width-50 mb-sm-1 font-lusitana bg_blue'
            // style={{ borderRadius: '0px' }}
          >
            <div className='d-flex justify-content-between align-items-center card-header px-0 '>
              {/* <i
                  className={`fa fa-angle-left ques_arrow pointer_class ${
                    this.state.hide_case_left_arrow
                  }`}
                  onClick={this._getPreviousCase}
                /> */}

              <button
                type='button'
                disabled={this.state.hide_case_left_arrow}
                className='btn btn-primary pointer_class'
                onClick={this._getPreviousCase}
              >
                Previous Passage
              </button>

              {/* <i
                  className={`fa fa-angle-right ques_arrow pointer_class ${
                    this.state.hide_case_right_arrow
                  }`}
                  onClick={this._getNextCase}
                /> */}

              <button
                type='button'
                className='btn btn-primary pointer_class'
                disabled={this.state.hide_case_right_arrow}
                onClick={this._getNextCase}
              >
                Next Passage
              </button>
            </div>{' '}
            <div className='mt-1'>
              {console.log('check case data', this.state.cases_display)}
              {renderHTMLContent(this.state.cases_display, 'span', '', {
                contentEditable: 'false',
                suppressContentEditableWarning: true,
              })}
            </div>
          </div>
          {/* =============================== TODO QA REPORT START================================== */}
          <div
            className='width-50 calc_height_GMAT overflow-y-auto width-sm-100 card-border-radius-none bg-white p-2 card font-lusitana bg_blue'
            // style={{ borderRadius: '0px' }}
          >
            <div className={'position-relative ' + this.state.top_50}>
              <div className={'main_loader ' + this.state.display_main_loader}>
                <div className='loader-mid'>
                  <div className='card-block-loader'>
                    <Loader />
                  </div>
                </div>
                {/* <i className='fa fa-spinner fa-spin ' /> */}
              </div>
              {question_data}
            </div>
          </div>
          {/* =============================== TODO QA REPORT END================================== */}
          {/* </div> */}
        </div>
        <div className={'loader_box ' + this.state.display_loader}>
          <div className='sk-circle'>
            <div className='sk-circle1 sk-child' />
            <div className='sk-circle2 sk-child' />
            <div className='sk-circle3 sk-child' />
            <div className='sk-circle4 sk-child' />
            <div className='sk-circle5 sk-child' />
            <div className='sk-circle6 sk-child' />
            <div className='sk-circle7 sk-child' />
            <div className='sk-circle8 sk-child' />
            <div className='sk-circle9 sk-child' />
            <div className='sk-circle10 sk-child' />
            <div className='sk-circle11 sk-child' />
            <div className='sk-circle12 sk-child' />
          </div>
        </div>
      </div>
    );
  }
}

// class TooltipItem extends React.Component {
//   constructor(props) {
//     super(props);

//     this.toggle = this.toggle.bind(this);

//     // document.body.style.backgroundColor = '#1d364b';
//     this.state = {
//       tooltipOpen: false,
//     };
//   }

//   toggle() {
//     this.setState({
//       // tooltipOpen: !tooltipOpen,
//     });
//   }

//   render() {
//     return (
//       <span>
//         <img
//           src={App_data.frontend_url + '/img/dashboard/info_icon.svg'}
//           id={'Tooltip-' + this.props.id}
//           width='18'
//           alt=''
//           style={{ marginLeft: '4px' }}
//         />
//         {/*<i className="fa fa-info-circle"  id={'Tooltip-' + this.props.id} ></i>*/}

//         <Tooltip
//           placement={this.props.place_tip}
//           // isOpen={tooltipOpen}
//           target={'Tooltip-' + this.props.id}
//           toggle={this.toggle}
//         >
//           <p className='tooltip_text'>{this.props.content}</p>
//         </Tooltip>
//       </span>
//     );
//   }
// }
export default GMATCases;



// WEBPACK FOOTER //
// ./src/views/GMATFocus/QuestionBank/SpecialQuestions/GMATCases.js